module.exports = __webpack_public_path__ + "img/b.5d0c3ca3.jpg";